import { useEffect } from 'react'
import { Navigate, Outlet } from 'react-router'
import { useAuthStore } from '@/store/auth-store'
import { PageLoader } from '@/shared/components/page-loader'
import { BrandPattern, BrandWordmark } from '@/shared/components/brand-pattern'
import { ClipboardIcon, WalletIcon, ShieldCheckIcon } from '@/shared/components/icons'

const highlights = [
  {
    icon: ClipboardIcon,
    title: 'Submit and track enquiries',
    body: 'Send a customer to PSN Fintech and follow every stage without chasing anyone.',
  },
  {
    icon: WalletIcon,
    title: 'Raise invoices, get paid',
    body: 'See your approved payout, GST and TDS before you invoice.',
  },
  {
    icon: ShieldCheckIcon,
    title: 'Paid to your verified bank',
    body: 'Payouts go only to the bank account you have verified with us.',
  },
]

export function PublicLayout() {
  const { status, initialize } = useAuthStore()

  useEffect(() => {
    initialize()
  }, [initialize])

  if (status === 'loading') {
    return <PageLoader />
  }

  if (status === 'authenticated') {
    return <Navigate to="/" replace />
  }

  return (
    <div className="relative min-h-screen overflow-hidden bg-navy-900">
      <BrandPattern className="text-white" />

      <div className="relative mx-auto flex min-h-screen max-w-7xl items-center px-4 py-10 md:px-8 lg:px-12">
        <div className="grid w-full items-center gap-12 lg:grid-cols-[1.05fr_1fr] lg:gap-16">
          <section className="hidden text-white lg:block">
            <BrandWordmark tone="dark" className="h-11" />

            <h2 className="mt-10 max-w-md text-3xl font-bold leading-tight tracking-tight xl:text-4xl">
              The connector portal for everything you bring to PSN Fintech.
            </h2>

            <ul className="mt-9 space-y-6">
              {highlights.map(({ icon: Icon, title, body }) => (
                <li key={title} className="flex gap-4">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white/10">
                    <Icon className="h-5 w-5 text-brand-300" aria-hidden="true" />
                  </span>
                  <div className="min-w-0">
                    <p className="text-sm font-bold">{title}</p>
                    <p className="mt-1 max-w-sm text-sm leading-relaxed text-navy-200">{body}</p>
                  </div>
                </li>
              ))}
            </ul>
          </section>

          <main className="mx-auto w-full max-w-md">
            <div className="mb-8 flex justify-center lg:hidden">
              <BrandWordmark tone="dark" />
            </div>

            <Outlet />

            <p className="mt-8 text-center text-xs text-navy-300">
              PSN Fintech Private Limited
            </p>
          </main>
        </div>
      </div>
    </div>
  )
}
